import { Language } from "../language";
import { getRoute } from "@environment/type";


export default [
  //首页
  {
    path: getRoute() + "home",
    name: "home",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      title: "vTrack",
      leftBtnHide: true,
      rightBtnShow: true,
      stickyHeader: true,
      footerShow: true,
    }
  },
  {
    path: getRoute() + "activate",
    name: "activate",
    component: _ => import("@/views/main/enter/Activate.vue"),
    meta: {
      title: Language.auth.activate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "myInfo",
    name: "myInfo",
    component: () => import("@/views/main/myHome/myInfo.vue"),
    meta: {
      title: Language.information.title,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "enterpriseInfo",
    name: "enterpriseInfo",
    component: () => import("@/views/main/myHome/enterpriseInfo.vue"),
    meta: {
      title: Language.enterpriseInfo.title,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "base64Print",
    name: "base64Print",
    component: () => import("@/views/print/base64Print.vue"),
    meta: {
      title: Language.router.print,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "enterpriseWorkbench",
    name: "enterpriseWorkbench",
    component: () => import("@/views/main/myHome/enterpriseWorkbench.vue"),
    meta: {
      title: Language.router.enterpriseWorkbench,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "workbenchBank",
    name: "workbenchBank",
    component: () => import("@/views/main/myHome/workbenchBank.vue"),
    meta: {
      title: Language.router.workbenchBank,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "workbenchSupplier",
    name: "workbenchSupplier",
    component: () => import("@/views/main/myHome/workbenchSupplier.vue"),
    meta: {
      title: Language.router.workbenchSupplier,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightPriceCalculator",
    name: "freightPriceCalculator",
    component: () => import("@/views/main/freightPriceCalculator/freightPriceCalculator.vue"),
    meta: {
      title: Language.router.freightPriceCalculator,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "buildWayBillNo",
    name: "buildWayBillNo",
    component: () => import("@/views/main/logisticsManagement/buildWayBillNo.vue"),
    meta: {
      title: Language.router.buildWayBillNo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "checkWaybill",
    name: "checkWaybill",
    component: () => import("@/views/main/logisticsManagement/checkWaybill.vue"),
    meta: {
      title: Language.router.checkWaybill,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "checkWaybillDetail",
    name: "checkWaybill",
    component: () => import("@/views/main/logisticsManagement/checkWaybillDetail.vue"),
    meta: {
      title: Language.router.checkWaybillDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "billsReceivable",
    name: "billsReceivable",
    component: () => import("@/views/main/logisticsManagement/billsReceivable.vue"),
    meta: {
      title: Language.router.billsReceivable,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "supplierCostEntry",
    name: "supplierCostEntry",
    component: () => import("@/views/main/logisticsManagement/supplierCostEntry.vue"),
    meta: {
      title: Language.router.supplierCostEntry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "LogisticsStatus",
    name: "logisticsStatus",
    component: () => import("@/views/main/logisticsManagement/LogisticsStatus.vue"),
    meta: {
      title: Language.router.logisticsStatus,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "jobSummary",
    name: "jobSummary",
    component: () => import("@/views/main/logisticsManagement/jobSummary.vue"),
    meta: {
      title: Language.router.jobSummary,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderWayBill",
    name: "orderWayBill",
    component: () => import("@/views/main/logisticsManagement/orderWayBill.vue"),
    meta: {
      title: Language.router.orderWayBill,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderWayBillDetail",
    name: "orderWayBillDetail",
    component: () => import("@/views/main/logisticsManagement/orderWayBillDetail.vue"),
    meta: {
      title: Language.router.orderWayBillDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsFiles",
    name: "goodsFiles",
    component: () => import("@/views/main/logisticsManagement/goodsFiles.vue"),
    meta: {
      title: Language.router.goodsFiles,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsFilesDetail",
    name: "goodsFilesDetail",
    component: () => import("@/views/main/logisticsManagement/goodsFilesDetail.vue"),
    meta: {
      title: Language.router.goodsFilesDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "preAlertList",
    name: "preAlertList",
    component: () => import("@/views/main/logisticsManagement/preAlertList.vue"),
    meta: {
      title: "Pre-Alert",
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "preAlert",
    name: "preAlert",
    component: () => import("@/views/main/logisticsManagement/preAlert.vue"),
    meta: {
      title: "Shipment Pre-Alert",
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "preAlertDetail",
    name: "preAlertDetail",
    component: () => import("@/views/main/logisticsManagement/preAlertDetail.vue"),
    meta: {
      title: Language.router.preAlertDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "vehiclesList",
    name: "vehiclesList",
    component: () => import("@/views/main/logisticsManagement/vehiclesList.vue"),
    meta: {
      title: Language.router.vehiclesList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "vehiclesDetail",
    name: "vehiclesDetail",
    component: () => import("@/views/main/logisticsManagement/vehiclesDetail.vue"),
    meta: {
      title: Language.router.vehiclesDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expressEmployeeList",
    name: "expressEmployeeList",
    component: () => import("@/views/main/logisticsManagement/expressEmployeeList.vue"),
    meta: {
      title: Language.router.expressEmployeeList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expressEmployeeDetail",
    name: "expressEmployeeDetail",
    component: () => import("@/views/main/logisticsManagement/expressEmployeeDetail.vue"),
    meta: {
      title: Language.router.expressEmployeeDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "temuManifestList",
    name: "temuManifestList",
    component: () => import("@/views/main/platformOrders/temuManifestList.vue"),
    meta: {
      title: Language.router.temuManifestList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "temuManifestDetail",
    name: "temuManifestDetail",
    component: () => import("@/views/main/platformOrders/temuManifestDetail.vue"),
    meta: {
      title: Language.router.temuManifestDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "tmsDetail",
    name: "tmsDetail",
    component: () => import("@/views/main/platformOrders/tmsDetail.vue"),
    meta: {
      title: Language.router.tmsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "basicInfo",
    name: "basicInfo",
    component: () => import("@/views/main/customerManagement/basicInfo.vue"),
    meta: {
      title: Language.router.basicInfo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "basicInfoDetail",
    name: "basicInfoDetail",
    component: () => import("@/views/main/customerManagement/basicInfoDetail.vue"),
    meta: {
      title: Language.router.basicInfoDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "basicInfoAgentList",
    name: "basicInfoAgentList",
    component: () => import("@/views/main/customerManagement/basicInfoAgentList.vue"),
    meta: {
      title: Language.router.basicInfoAgentList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "basicInfoAgentDetail",
    name: "basicInfoAgentDetail",
    component: () => import("@/views/main/customerManagement/basicInfoAgentDetail.vue"),
    meta: {
      title: Language.router.basicInfoAgentDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "banckAccountInfo",
    name: "banckAccountInfo",
    component: () => import("@/views/main/customerManagement/banckAccountInfo.vue"),
    meta: {
      title: Language.router.banckAccountInfo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "banckAccountInfoDetail",
    name: "banckAccountInfoDetail",
    component: () => import("@/views/main/customerManagement/banckAccountInfoDetail.vue"),
    meta: {
      title: Language.router.banckAccountInfoDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "contactStaff",
    name: "contactStaff",
    component: () => import("@/views/main/customerManagement/contactStaff.vue"),
    meta: {
      title: Language.router.contactStaff,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "contactStaffDetail",
    name: "contactStaffDetail",
    component: () => import("@/views/main/customerManagement/contactStaffDetail.vue"),
    meta: {
      title: Language.router.contactStaffDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "contractManagement",
    name: "contractManagement",
    component: () => import("@/views/main/customerManagement/contractManagement.vue"),
    meta: {
      title: Language.router.contractManagement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "contractManagementDetail",
    name: "contractManagementDetail",
    component: () => import("@/views/main/customerManagement/contractManagementDetail.vue"),
    meta: {
      title: Language.router.contractManagementDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "receivingAccountManagement",
    name: "receivingAccountManagement",
    component: () => import("@/views/main/financialManagement/financialBill/receivingAccountManagement.vue"),
    meta: {
      title: Language.router.receivingAccountManagement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "receivingAccountManagementDetail",
    name: "receivingAccountManagementDetail",
    component: () => import("@/views/main/financialManagement/financialBill/receivingAccountManagementDetail.vue"),
    meta: {
      title: Language.router.receivingAccountManagementDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expenseNameManagement",
    name: "expenseNameManagement",
    component: () => import("@/views/main/financialManagement/financialBill/expenseNameManagement.vue"),
    meta: {
      title: Language.router.expenseNameManagement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expenseNameManagementDetail",
    name: "expenseNameManagementDetail",
    component: () => import("@/views/main/financialManagement/financialBill/expenseNameManagementDetail.vue"),
    meta: {
      title: Language.router.expenseNameManagementDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "exchangeRateInfo",
    name: "exchangeRateInfo",
    component: () => import("@/views/main/financialManagement/financialBill/exchangeRateInfo.vue"),
    meta: {
      title: Language.router.exchangeRateInfo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "exchangeRateInfoDetail",
    name: "exchangeRateInfoDetail",
    component: () => import("@/views/main/financialManagement/financialBill/exchangeRateInfoDetail.vue"),
    meta: {
      title: Language.router.exchangeRateInfoDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "exchangeRateInfoLog",
    name: "exchangeRateInfoLog",
    component: () => import("@/views/main/financialManagement/financialBill/exchangeRateInfoLog.vue"),
    meta: {
      title: Language.router.exchangeRateInfoLog,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "invoiceItemList",
    name: "invoiceItemList",
    component: () => import("@/views/main/financialManagement/financialBill/invoiceItemList.vue"),
    meta: {
      title: Language.router.invoiceItemList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "invoiceItemListDetail",
    name: "invoiceItemListDetail",
    component: () => import("@/views/main/financialManagement/financialBill/invoiceItemListDetail.vue"),
    meta: {
      title: Language.router.invoiceItemListDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "reportQuerySummary",
    name: "reportQuerySummary",
    component: () => import("@/views/main/financialManagement/businessLedger/reportQuerySummary.vue"),
    meta: {
      title: Language.router.reportQuerySummary,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "reportQuerySummaryDetail",
    name: "reportQuerySummaryDetail",
    component: () => import("@/views/main/financialManagement/businessLedger/reportQuerySummaryDetail.vue"),
    meta: {
      title: Language.router.reportQuerySummaryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payrollDetails",
    name: "payrollDetails",
    component: () => import("@/views/main/financialManagement/businessLedger/payrollDetails.vue"),
    meta: {
      title: Language.router.payrollDetails,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "profitableList",
    name: "profitableList",
    component: () => import("@/views/main/financialManagement/businessLedger/profitableList.vue"),
    meta: {
      title: Language.router.profitableList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "profitableListDetail",
    name: "profitableListDetail",
    component: () => import("@/views/main/financialManagement/businessLedger/profitableListDetail.vue"),
    meta: {
      title: Language.router.profitableListDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "finishedCheckBillsSummary",
    name: "finishedCheckBillsSummary",
    component: () => import("@/views/main/financialManagement/businessLedger/finishedCheckBillsSummary.vue"),
    meta: {
      title: Language.router.finishedCheckBillsSummary,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "finishedCheckBillsSummaryDetail",
    name: "finishedCheckBillsSummaryDetail",
    component: () => import("@/views/main/financialManagement/businessLedger/finishedCheckBillsSummaryDetail.vue"),
    meta: {
      title: Language.router.finishedCheckBillsSummaryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "creditedDetails",
    name: "creditedDetails",
    component: () => import("@/views/main/financialManagement/businessLedger/creditedDetails.vue"),
    meta: {
      title: Language.router.creditedDetails,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "creditedDetailsInfo",
    name: "creditedDetailsInfo",
    component: () => import("@/views/main/financialManagement/businessLedger/creditedDetailsInfo.vue"),
    meta: {
      title: Language.router.creditedDetailsInfo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payrollList",
    name: "payrollList",
    component: () => import("@/views/main/financialManagement/businessLedger/payrollList.vue"),
    meta: {
      title: Language.router.payrollList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payrollRequest",
    name: "payrollRequest",
    component: () => import("@/views/main/financialManagement/businessLedger/payrollRequest.vue"),
    meta: {
      title: Language.router.payrollRequest,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payrollPayment",
    name: "payrollPayment",
    component: () => import("@/views/main/financialManagement/businessLedger/payrollPayment.vue"),
    meta: {
      title: Language.router.payrollPayment,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payrollRecords",
    name: "payrollRecords",
    component: () => import("@/views/main/financialManagement/businessLedger/payrollRecords.vue"),
    meta: {
      title: Language.router.payrollRecords,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "taxInvoice",
    name: "taxInvoice",
    component: () => import("@/views/main/financialManagement/businessLedger/taxInvoice.vue"),
    meta: {
      title: Language.router.taxInvoice,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "taxInvoiceDetail",
    name: "taxInvoiceDetail",
    component: () => import("@/views/main/financialManagement/businessLedger/taxInvoiceDetail.vue"),
    meta: {
      title: Language.router.taxInvoiceDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financialRequest",
    name: "financialRequest",
    component: () => import("@/views/main/financialManagement/businessLedger/financialRequest.vue"),
    meta: {
      title: Language.router.financialRequest,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financialRequestDetail",
    name: "financialRequestDetail",
    component: () => import("@/views/main/financialManagement/businessLedger/financialRequestDetail.vue"),
    meta: {
      title: Language.router.financialRequestDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financialAudit",
    name: "financialAudit",
    component: () => import("@/views/main/financialManagement/businessLedger/financialAudit.vue"),
    meta: {
      title: Language.router.financialAudit,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financialAuditDetail",
    name: "financialAuditDetail",
    component: () => import("@/views/main/financialManagement/businessLedger/financialAuditDetail.vue"),
    meta: {
      title: Language.router.financialAuditDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "paymentInvoice",
    name: "paymentInvoice",
    component: () => import("@/views/main/financialManagement/businessLedger/paymentInvoice.vue"),
    meta: {
      title: Language.router.paymentInvoice,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoStatistics",
    name: "cargoStatistics",
    component: () => import("@/views/main/financialManagement/summaryReport/cargoStatistics.vue"),
    meta: {
      title: Language.router.cargoStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "lineChartStatistics",
    name: "lineChartStatistics",
    component: () => import("@/views/main/financialManagement/summaryReport/lineChartStatistics.vue"),
    meta: {
      title: Language.router.lineChartStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expenseStatistics",
    name: "expenseStatistics",
    component: () => import("@/views/main/financialManagement/summaryReport/expenseStatistics.vue"),
    meta: {
      title: Language.router.expenseStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expenseStatisticsDetail",
    name: "expenseStatisticsDetail",
    component: () => import("@/views/main/financialManagement/summaryReport/expenseStatisticsDetail.vue"),
    meta: {
      title: Language.router.expenseStatisticsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "customerBusinessStatistics",
    name: "customerBusinessStatistics",
    component: () => import("@/views/main/financialManagement/summaryReport/customerBusinessStatistics.vue"),
    meta: {
      title: Language.router.customerBusinessStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "customerBusinessStatisticsDetail",
    name: "customerBusinessStatisticsDetail",
    component: () => import("@/views/main/financialManagement/summaryReport/customerBusinessStatisticsDetail.vue"),
    meta: {
      title: Language.router.customerBusinessStatisticsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "customerBusinessStatisticsCustomerInfo",
    name: "customerBusinessStatisticsCustomerInfo",
    component: () => import("@/views/main/financialManagement/summaryReport/customerBusinessStatisticsCustomerInfo.vue"),
    meta: {
      title: Language.router.customerBusinessStatisticsCustomerInfo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "seaFreightDataStatistics",
    name: "seaFreightDataStatistics",
    component: () => import("@/views/main/financialManagement/summaryReport/seaFreightDataStatistics.vue"),
    meta: {
      title: Language.router.seaFreightDataStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "seaFreightDataStatisticsDetail",
    name: "seaFreightDataStatisticsDetail",
    component: () => import("@/views/main/financialManagement/summaryReport/seaFreightDataStatisticsDetail.vue"),
    meta: {
      title: Language.router.seaFreightDataStatisticsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "exportGoodsStatistics",
    name: "exportGoodsStatistics",
    component: () => import("@/views/main/financialManagement/summaryReport/exportGoodsStatistics.vue"),
    meta: {
      title: Language.router.exportGoodsStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "businessEntry",
    name: "businessEntry",
    component: () => import("@/views/main/financialManagement/clientFund/businessEntry.vue"),
    meta: {
      title: Language.router.businessEntry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "businessEntryDetail",
    name: "businessEntryDetail",
    component: () => import("@/views/main/financialManagement/clientFund/businessEntryDetail.vue"),
    meta: {
      title: Language.router.businessEntryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financeEntry",
    name: "financeEntry",
    component: () => import("@/views/main/financialManagement/clientFund/financeEntry.vue"),
    meta: {
      title: Language.router.financeEntry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financeEntryDetail",
    name: "financeEntryDetail",
    component: () => import("@/views/main/financialManagement/clientFund/financeEntryDetail.vue"),
    meta: {
      title: Language.router.financeEntryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "accountStatements",
    name: "accountStatements",
    component: () => import("@/views/main/financialManagement/clientFund/accountStatements.vue"),
    meta: {
      title: Language.router.accountStatements,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "accountStatementsDetail",
    name: "accountStatementsDetail",
    component: () => import("@/views/main/financialManagement/clientFund/accountStatementsDetail.vue"),
    meta: {
      title: Language.router.accountStatementsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "clientFundDetail",
    name: "clientFundDetail",
    component: () => import("@/views/main/financialManagement/clientFund/clientFundDetail.vue"),
    meta: {
      title: Language.router.clientFundDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "clientFundDetailExchange",
    name: "clientFundDetailExchange",
    component: () => import("@/views/main/financialManagement/clientFund/clientFundDetailExchange.vue"),
    meta: {
      title: Language.router.clientFundDetailExchange,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "clientFundDetailWriteOff",
    name: "clientFundDetailWriteOff",
    component: () => import("@/views/main/financialManagement/clientFund/clientFundDetailWriteOff.vue"),
    meta: {
      title: Language.router.clientFundDetailWriteOff,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "clientFundUseList",
    name: "clientFundUseList",
    component: () => import("@/views/main/financialManagement/clientFund/clientFundUseList.vue"),
    meta: {
      title: Language.router.clientFundUseList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "clientFundExchange",
    name: "clientFundExchange",
    component: () => import("@/views/main/financialManagement/clientFund/clientFundExchange.vue"),
    meta: {
      title: Language.router.clientFundExchange,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "clientFundDataList",
    name: "clientFundDataList",
    component: () => import("@/views/main/financialManagement/clientFund/clientFundDataList.vue"),
    meta: {
      title: Language.router.clientFundDataList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseList",
    name: "warehouseList",
    component: () => import("@/views/main/warehouseManagement/warehouseList.vue"),
    meta: {
      title: Language.router.warehouseList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseDetail",
    name: "warehouseDetail",
    component: () => import("@/views/main/warehouseManagement/warehouseDetail.vue"),
    meta: {
      title: Language.router.warehouseDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseSettings",
    name: "warehouseSettings",
    component: () => import("@/views/main/warehouseManagement/warehouseSettings.vue"),
    meta: {
      title: Language.router.warehouseSettings,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseSettingsDetail",
    name: "warehouseSettingsDetail",
    component: () => import("@/views/main/warehouseManagement/warehouseSettingsDetail.vue"),
    meta: {
      title: Language.router.warehouseSettingsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseDelivery",
    name: "warehouseDelivery",
    component: () => import("@/views/main/warehouseManagement/warehouseDelivery.vue"),
    meta: {
      title: Language.router.warehouseDelivery,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseDeliveryDetail",
    name: "warehouseDeliveryDetail",
    component: () => import("@/views/main/warehouseManagement/warehouseDeliveryDetail.vue"),
    meta: {
      title: Language.router.warehouseDeliveryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseBill",
    name: "warehouseBill",
    component: () => import("@/views/main/warehouseManagement/warehouseBill.vue"),
    meta: {
      title: Language.router.warehouseBill,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseBillDetail",
    name: "warehouseBillDetail",
    component: () => import("@/views/main/warehouseManagement/warehouseBillDetail.vue"),
    meta: {
      title: Language.router.warehouseBillDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseProfitAccounting",
    name: "warehouseProfitAccounting",
    component: () => import("@/views/main/warehouseManagement/warehouseProfitAccounting.vue"),
    meta: {
      title: Language.router.warehouseProfitAccounting,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseOperationLogList",
    name: "warehouseOperationLogList",
    component: () => import("@/views/main/warehouseManagement/warehouseOperationLogList.vue"),
    meta: {
      title: Language.router.warehouseOperationLogList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoWarehousingList",
    name: "cargoWarehousingList",
    component: () => import("@/views/main/warehouseManagement/cargoWarehousingList.vue"),
    meta: {
      title: Language.router.cargoWarehousingList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoWarehousingDetail",
    name: "cargoWarehousingDetail",
    component: () => import("@/views/main/warehouseManagement/cargoWarehousingDetail.vue"),
    meta: {
      title: Language.router.cargoWarehousingDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoWarehousingException",
    name: "cargoWarehousingException",
    component: () => import("@/views/main/warehouseManagement/cargoWarehousingException.vue"),
    meta: {
      title: Language.router.cargoWarehousingException,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoWarehousingExceptionRecords",
    name: "cargoWarehousingExceptionRecords",
    component: () => import("@/views/main/warehouseManagement/cargoWarehousingExceptionRecords.vue"),
    meta: {
      title: Language.router.cargoWarehousingExceptionRecords,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoWarehousing",
    name: "cargoWarehousing",
    component: () => import("@/views/main/warehouseManagement/cargoWarehousing.vue"),
    meta: {
      title: Language.router.cargoWarehousing,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "cargoWarehousingEditAddress",
    name: "cargoWarehousingEditAddress",
    component: () => import("@/views/main/warehouseManagement/cargoWarehousingEditAddress.vue"),
    meta: {
      title: Language.router.cargoWarehousingEditAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationManagement",
    name: "quotationManagement",
    component: () => import("@/views/main/onlineOrderManagement/quotationManagement.vue"),
    meta: {
      title: Language.router.quotationManagement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationCustomerDiscount",
    name: "quotationCustomerDiscount",
    component: () => import("@/views/main/onlineOrderManagement/quotationCustomerDiscount.vue"),
    meta: {
      title: Language.router.quotationCustomerDiscount,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationCustomerDiscountDetail",
    name: "quotationCustomerDiscountDetail",
    component: () => import("@/views/main/onlineOrderManagement/quotationCustomerDiscountDetail.vue"),
    meta: {
      title: Language.router.quotationCustomerDiscountDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationIntegration",
    name: "quotationIntegration",
    component: () => import("@/views/main/onlineOrderManagement/quotationIntegration.vue"),
    meta: {
      title: Language.router.quotationIntegration,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationIntegrationHistory",
    name: "quotationIntegrationHistory",
    component: () => import("@/views/main/onlineOrderManagement/quotationIntegrationHistory.vue"),
    meta: {
      title: Language.router.quotationIntegrationHistory,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationSupplierCreate",
    name: "quotationSupplierCreate",
    component: () => import("@/views/main/onlineOrderManagement/quotationSupplierCreate.vue"),
    meta: {
      title: Language.router.quotationSupplierCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "waitingForStorage",
    name: "waitingForStorage",
    component: () => import("@/views/main/onlineOrderManagement/waitingForStorage.vue"),
    meta: {
      title: Language.router.waitingForStorage,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "hasBeenStored",
    name: "hasBeenStored",
    component: () => import("@/views/main/onlineOrderManagement/hasBeenStored.vue"),
    meta: {
      title: Language.router.hasBeenStored,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "hasBeenStoredDetail",
    name: "hasBeenStoredDetail",
    component: () => import("@/views/main/onlineOrderManagement/hasBeenStoredDetail.vue"),
    meta: {
      title: Language.router.hasBeenStoredDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "departed",
    name: "departed",
    component: () => import("@/views/main/onlineOrderManagement/departed.vue"),
    meta: {
      title: Language.router.departed,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "departedDetail",
    name: "departedDetail",
    component: () => import("@/views/main/onlineOrderManagement/departedDetail.vue"),
    meta: {
      title: Language.router.departedDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationWarehouse",
    name: "quotationWarehouse",
    component: () => import("@/views/main/onlineOrderManagement/quotationWarehouse.vue"),
    meta: {
      title: Language.router.quotationWarehouse,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationInformation",
    name: "quotationInformation",
    component: () => import("@/views/main/onlineOrderManagement/quotationInformation.vue"),
    meta: {
      title: Language.router.quotationInformation,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quotationFreight",
    name: "quotationFreight",
    component: () => import("@/views/main/onlineOrderManagement/quotationFreight.vue"),
    meta: {
      title: Language.router.quotationFreight,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "advertList",
    name: "advertList",
    component: () => import("@/views/main/marketRisk/advertList.vue"),
    meta: {
      title: Language.router.advertList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "advertDetail",
    name: "advertDetail",
    component: () => import("@/views/main/marketRisk/advertDetail.vue"),
    meta: {
      title: Language.router.advertDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "restrictedList",
    name: "restrictedList",
    component: () => import("@/views/main/marketRisk/restrictedList.vue"),
    meta: {
      title: Language.router.restrictedList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "restrictedDetail",
    name: "restrictedDetail",
    component: () => import("@/views/main/marketRisk/restrictedDetail.vue"),
    meta: {
      title: Language.router.restrictedDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "emailConfig",
    name: "emailConfig",
    component: () => import("@/views/main/marketRisk/emailConfig.vue"),
    meta: {
      title: Language.router.emailConfig,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "emailConfigDetail",
    name: "emailConfigDetail",
    component: () => import("@/views/main/marketRisk/emailConfigDetail.vue"),
    meta: {
      title: Language.router.emailConfigDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "antiMoneyLaunderingList",
    name: "antiMoneyLaunderingList",
    component: () => import("@/views/main/marketRisk/antiMoneyLaunderingList.vue"),
    meta: {
      title: Language.router.antiMoneyLaunderingList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "antiMoneyLaunderingDetail",
    name: "antiMoneyLaunderingDetail",
    component: () => import("@/views/main/marketRisk/antiMoneyLaunderingDetail.vue"),
    meta: {
      title: Language.router.antiMoneyLaunderingDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "antiMoneyLaunderingQuery",
    name: "antiMoneyLaunderingQuery",
    component: () => import("@/views/main/marketRisk/antiMoneyLaunderingQuery.vue"),
    meta: {
      title: Language.router.antiMoneyLaunderingQuery,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quoteList",
    name: "quoteList",
    component: () => import("@/views/main/salesManagement/quoteList.vue"),
    meta: {
      title: Language.router.quoteList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quoteDetail",
    name: "quoteDetail",
    component: () => import("@/views/main/salesManagement/quoteDetail.vue"),
    meta: {
      title: Language.router.quoteDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "quoteCreate",
    name: "quoteCreate",
    component: () => import("@/views/main/salesManagement/quoteCreate.vue"),
    meta: {
      title: Language.router.quoteCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderCenterList",
    name: "orderCenterList",
    component: () => import("@/views/main/salesManagement/orderCenterList.vue"),
    meta: {
      title: Language.router.orderCenterList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "commissionDetail",
    name: "commissionDetail",
    component: () => import("@/views/main/salesManagement/commissionDetail.vue"),
    meta: {
      title: Language.router.commissionDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "commissionCreate",
    name: "commissionCreate",
    component: () => import("@/views/main/salesManagement/commissionCreate.vue"),
    meta: {
      title: Language.router.commissionCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "accountingList",
    name: "accountingList",
    component: () => import("@/views/main/salesManagement/accountingList.vue"),
    meta: {
      title: Language.router.accountingList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "accountingDetail",
    name: "accountingDetail",
    component: () => import("@/views/main/salesManagement/accountingDetail.vue"),
    meta: {
      title: Language.router.accountingDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "supplierServiceInformation",
    name: "supplierServiceInformation",
    component: () => import("@/views/main/supplierManagement/supplierServiceInformation.vue"),
    meta: {
      title: Language.router.supplierServiceInformation,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "supplierInformation",
    name: "supplierInformation",
    component: () => import("@/views/main/supplierManagement/supplierInformation.vue"),
    meta: {
      title: Language.router.supplierInformation,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "answerDetail",
    name: "answerDetail",
    component: () => import("@/views/main/supplierManagement/answerDetail.vue"),
    meta: {
      title: Language.router.answerDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "overseasGrid",
    name: "overseasGrid",
    component: () => import("@/views/main/supplierManagement/overseasGrid.vue"),
    meta: {
      title: Language.router.overseasGrid,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "overseasDetail",
    name: "overseasDetail",
    component: () => import("@/views/main/supplierManagement/overseasDetail.vue"),
    meta: {
      title: Language.router.overseasDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "assetsStatistics",
    name: "assetsStatistics",
    component: () => import("@/views/main/enterpriseLogistics/assetsStatistics.vue"),
    meta: {
      title: Language.router.assetsStatistics,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "assetsStatisticsDetail",
    name: "assetsStatisticsDetail",
    component: () => import("@/views/main/enterpriseLogistics/assetsStatisticsDetail.vue"),
    meta: {
      title: Language.router.assetsStatisticsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "assetsStatisticsRecord",
    name: "assetsStatisticsRecord",
    component: () => import("@/views/main/enterpriseLogistics/assetsStatisticsRecord.vue"),
    meta: {
      title: Language.router.assetsStatisticsRecord,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "employeeInformation",
    name: "employeeInformation",
    component: () => import("@/views/main/myHome/employeeInformation.vue"),
    meta: {
      title: Language.router.employeeInformation,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "employeeManagement",
    name: "employeeManagement",
    component: () => import("@/views/main/enterpriseLogistics/employeeManagement.vue"),
    meta: {
      title: Language.router.employeeManagement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "employeeDetail",
    name: "employeeDetail",
    component: () => import("@/views/main/enterpriseLogistics/employeeDetail.vue"),
    meta: {
      title: Language.router.employeeDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "businessEntitySettings",
    name: "businessEntitySettings",
    component: () => import("@/views/main/systemManagement/businessEntitySettings.vue"),
    meta: {
      title: Language.router.businessEntitySettings,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "businessEntitySettingsDetail",
    name: "businessEntitySettingsDetail",
    component: () => import("@/views/main/systemManagement/businessEntitySettingsDetail.vue"),
    meta: {
      title: Language.router.businessEntitySettingsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsInventory",
    name: "goodsInventory",
    component: () => import("@/views/main/purchasingManagement/goodsInventory.vue"),
    meta: {
      title: Language.router.goodsInventory,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsInventoryCreate",
    name: "goodsInventoryCreate",
    component: () => import("@/views/main/purchasingManagement/goodsInventoryCreate.vue"),
    meta: {
      title: Language.router.goodsInventoryCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsInventoryQuotation",
    name: "goodsInventoryQuotation",
    component: () => import("@/views/main/purchasingManagement/goodsInventoryQuotation.vue"),
    meta: {
      title: Language.router.goodsInventoryQuotation,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "goodsInventoryQuotationDetail",
    name: "goodsInventoryQuotationDetail",
    component: () => import("@/views/main/purchasingManagement/goodsInventoryQuotationDetail.vue"),
    meta: {
      title: Language.router.goodsInventoryQuotationDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "tradeOrder",
    name: "tradeOrder",
    component: () => import("@/views/main/purchasingManagement/tradeOrder.vue"),
    meta: {
      title: Language.router.tradeOrder,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "tradeOrderCreate",
    name: "tradeOrderCreate",
    component: () => import("@/views/main/purchasingManagement/tradeOrderCreate.vue"),
    meta: {
      title: Language.router.tradeOrderCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "tradeOrderReconciliation",
    name: "tradeOrderReconciliation",
    component: () => import("@/views/main/purchasingManagement/tradeOrderReconciliation.vue"),
    meta: {
      title: Language.router.tradeOrderReconciliation,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "procurementQuotationSettings",
    name: "procurementQuotationSettings",
    component: () => import("@/views/main/purchasingManagement/procurementQuotationSettings.vue"),
    meta: {
      title: Language.router.procurementQuotationSettings,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "procurementQuotationSettingsDetail",
    name: "procurementQuotationSettingsDetail",
    component: () => import("@/views/main/purchasingManagement/procurementQuotationSettingsDetail.vue"),
    meta: {
      title: Language.router.procurementQuotationSettingsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "currencySettings",
    name: "currencySettings",
    component: () => import("@/views/main/systemManagement/currencySettings.vue"),
    meta: {
      title: Language.router.currencySettings,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "currencySettingsDetail",
    name: "currencySettingsDetail",
    component: () => import("@/views/main/systemManagement/currencySettingsDetail.vue"),
    meta: {
      title: Language.router.currencySettingsDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "invoiceTitle",
    name: "invoiceTitle",
    component: () => import("@/views/main/systemManagement/invoiceTitle.vue"),
    meta: {
      title: Language.router.invoiceTitle,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "consumptionRecord",
    name: "consumptionRecord",
    component: () => import("@/views/main/systemManagement/consumptionRecord.vue"),
    meta: {
      title: Language.router.consumptionRecord,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "financialAuditProcessSettings",
    name: "financialAuditProcessSettings",
    component: () => import("@/views/main/systemManagement/financialAuditProcessSettings.vue"),
    meta: {
      title: Language.router.financialAuditProcessSettings,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "getWayBillOperationLog",
    name: "getWayBillOperationLog",
    component: () => import("@/views/main/systemManagement/getWayBillOperationLog.vue"),
    meta: {
      title: Language.router.getWayBillOperationLog,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "expenseCategorySettings",
    name: "expenseCategorySettings",
    component: () => import("@/views/main/systemManagement/expenseCategorySettings.vue"),
    meta: {
      title: Language.router.expenseCategorySettings,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "userList",
    name: "userList",
    component: () => import("@/views/main/systemManagement/userList.vue"),
    meta: {
      title: Language.router.userList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "userDetail",
    name: "userDetail",
    component: () => import("@/views/main/systemManagement/userDetail.vue"),
    meta: {
      title: Language.router.userDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "roleList",
    name: "roleList",
    component: () => import("@/views/main/systemManagement/roleList.vue"),
    meta: {
      title: Language.router.roleList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "roleDetail",
    name: "roleDetail",
    component: () => import("@/views/main/systemManagement/roleDetail.vue"),
    meta: {
      title: Language.router.roleDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "store",
    name: "store",
    component: () => import("@/views/main/systemManagement/store.vue"),
    meta: {
      title: Language.router.store,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "auth",
    component: _ => import("@/views/auth/Index.vue"),
    children: [
      {
        path: "",
        redirect: getRoute() + "auth/login"
      },
      {
        path: getRoute() + "auth/login",
        name: "login",
        component: _ => import("@/views/auth/Login.vue"),
        meta: {
          title: Language.auth.login,
          authBackground: true,
          stickyHeader: true,
          leftBtnHide: true,
        }
      },
      {
        path: getRoute() + "auth/register",
        name: "register",
        component: _ => import("@/views/auth/Register.vue"),
        meta: {
          title: Language.auth.register,
          authBackground: true,
          stickyHeader: true,
          leftBtnHide: true,
        }
      },
      {
        path: getRoute() + "auth/regInfo",
        name: "registerInfo",
        component: _ => import("@/views/auth/RegisterInfo.vue"),
        meta: {
          title: Language.auth.setAccountInfo,
          authBackground: true,
          stickyHeader: true,
          leftBtnHide: true,
        }
      },
      {
        path: getRoute() + "auth/resetPassword",
        name: "resetPassword",
        component: _ => import("@/views/auth/ResetPassword.vue"),
        meta: {
          title: Language.auth.forgetPassword,
          authBackground: true,
          stickyHeader: true,
          leftBtnHide: true,
        }
      },
    ]
  },
  {
    path: getRoute() + "user",
    name: "User",
    component: () => import("@/views/user/Index.vue"),
    children: [
      {
        path: "",
        redirect: getRoute() + "user/userManage"
      },
      {
        path: getRoute() + "user/userManage",
        name: "userManage",
        component: () => import("@/views/user/user-manage/UserManage.vue"),
        meta: {
          title: Language.meta.userManagement,
          footerShow: true,
          leftBtnHide: true,
          stickyHeader: true,
        }
      }
    ]
  },
  {
    path: getRoute() + "privacy",
    name: "privacy",
    component: () => import("@/views/privacy/privacy.vue"),
    meta: {
      title: Language.router.privacy,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payCompletion",
    name: "payCompletion",
    component: () => import("@/views/payment/payCompletion.vue"),
    meta: {
      title: Language.router.payCompletion,
      requiredAuth: false,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "payQrcode",
    name: "payQrcode",
    component: () => import("@/views/payment/payQrcode.vue"),
    meta: {
      title: Language.router.payQrcode,
      requiredAuth: false,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "accountDeletion",
    name: "accountDeletion",
    component: () => import("@/views/user/accountDeletion/accountDeletion.vue"),
    meta: {
      title: Language.router.accountDeletion,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "aboutUs",
    name: "aboutUs",
    component: () => import("@/views/user/about/aboutUs.vue"),
    meta: {
      title: Language.router.aboutUs,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "kefuList",
    name: "kefuList",
    component: () => import("@/views/user/kefu/kefuList.vue"),
    meta: {
      title: Language.router.kefuList,
      stickyHeader: true,
    }
  },
  //企业客户
  {
    path: getRoute() + "customerInfo",
    name: "customerInfo",
    component: () => import("@/views/main/myCustomer/customerHome/customerInfo.vue"),
    meta: {
      title: Language.router.customerInfo,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightInquiry",
    name: "FreightInquiry",
    component: () => import("@/views/main/myCustomer/freightInquiry/freightInquiry.vue"),
    meta: {
      title: Language.router.freightInquiry,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightInquiryDetail",
    name: "FreightInquiry",
    component: () => import("@/views/main/myCustomer/freightInquiry/freightInquiryDetail.vue"),
    meta: {
      title: Language.router.freightInquiryDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "customerQuotationDetail",
    name: "FreightInquiry",
    component: () => import("@/views/main/myCustomer/freightInquiry/customerQuotationDetail.vue"),
    meta: {
      title: Language.router.customerQuotationDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "shippingAddress",
    name: "shippingAddress",
    component: () => import("@/views/main/myCustomer/shippingAddress/shippingAddress.vue"),
    meta: {
      title: Language.router.shippingAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "editAddress",
    name: "EditAddress",
    component: () => import("@/views/main/myCustomer/edit-address/EditAddress.vue"),
    meta: {
      title: Language.router.addAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "editAddress/:id",
    name: "EditAddress",
    component: () => import("@/views/main/myCustomer/edit-address/EditAddress.vue"),
    props: true,
    meta: {
      title: Language.router.editAddress,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "myWallet",
    name: "AccountList",
    component: () => import("@/views/main/myCustomer/myWallet/myWallet.vue"),
    props: true,
    meta: {
      title: Language.router.myWallet,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "myWalletRechange",
    name: "myWalletRechange",
    component: () => import("@/views/main/myCustomer/myWallet/myWalletRechange.vue"),
    props: true,
    meta: {
      title: Language.router.myWalletRechange,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "paybillList",
    name: "PaybillList",
    component: () => import("@/views/main/myCustomer/paybill-list/paybill-list.vue"),
    props: true,
    meta: {
      title: Language.router.paybillList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderManagement",
    name: "orderManagement",
    component: () => import("@/views/main/myCustomer/orderManagement/orderManagement.vue"),
    props: true,
    meta: {
      title: Language.router.orderManagement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "orderManagementDetail",
    name: "orderManagementDetail",
    component: () => import("@/views/main/myCustomer/orderManagement/orderManagementDetail.vue"),
    props: true,
    meta: {
      title: Language.router.orderManagementDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "entrustOrder",
    name: "entrustOrder",
    component: () => import("@/views/main/myCustomer/entrustOrder/entrustOrder.vue"),
    props: true,
    meta: {
      title: Language.router.entrustOrderList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "entrustOrderCreate",
    name: "entrustOrderCreate",
    component: () => import("@/views/main/myCustomer/entrustOrder/entrustOrderCreate.vue"),
    meta: {
      title: Language.router.entrustOrderCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "entrustOrderDetail",
    name: "entrustOrderDetail",
    component: () => import("@/views/main/myCustomer/entrustOrder/entrustOrderDetail.vue"),
    meta: {
      title: Language.router.entrustOrderDetail,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightOrder",
    name: "freightOrder",
    component: () => import("@/views/main/myCustomer/freightOrder/freightOrder.vue"),
    props: true,
    meta: {
      title: Language.router.freightOrderList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "freightOrderCreate",
    name: "freightOrderCreate",
    component: () => import("@/views/main/myCustomer/freightOrder/freightOrderCreate.vue"),
    props: true,
    meta: {
      title: Language.router.freightOrderCreate,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseQuery",
    name: "warehouseQuery",
    component: () => import("@/views/main/myCustomer/warehouseQuery/warehouseQuery.vue"),
    props: true,
    meta: {
      title: Language.router.warehouseQuery,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "warehouseStatement",
    name: "warehouseStatement",
    component: () => import("@/views/main/myCustomer/warehouseStatement/warehouseStatement.vue"),
    props: true,
    meta: {
      title: Language.router.warehouseStatement,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "debtList",
    name: "debtList",
    component: () => import("@/views/main/myCustomer/debtList/debtList.vue"),
    props: true,
    meta: {
      title: Language.router.debtList,
      stickyHeader: true,
    }
  },
  {
    path: getRoute() + "debtDetail",
    name: "debtDetail",
    component: () => import("@/views/main/myCustomer/debtList/debtDetail.vue"),
    props: true,
    meta: {
      title: Language.router.debtDetail,
      stickyHeader: true,
    }
  },
];
